import { css } from '@emotion/react';
import { useDropdown } from 'hooks/useDropdown';
import { ReactNode, useRef, useState } from 'react';
import { theme } from 'styles/theme';
import { Input } from './Input';
import { IconSearch } from 'icons/icon-search';
import { ScrollBarStyle } from 'styles/ScrollBarStyle';

export const Select = ({
	onChange,
	value,
	placeholder,
	options,
	error,
	filterable,

	isCompositePrefix,
	sizeMedium,
}: {
	value: string;
	placeholder?: string;

	options: {
		label: string;
		value: string;
		icon: ReactNode;
	}[];

	error?: any;

	onChange: (e) => void;
	filterable?: boolean;

	isCompositePrefix?: boolean;

	sizeMedium?: boolean;
}) => {
	const dropdownRef = useRef();
	const [isOpen, toggle] = useDropdown(dropdownRef);

	const [searchInputValue, setSearchInputValue] = useState('');

	const currentOption = options?.find((item) => item.value === value);

	const filteredOptions = options?.filter((item) => {
		// console.log('searchInputValue', searchInputValue);
		// console.log('filter', item);

		if (item.label.toLowerCase().indexOf(searchInputValue.toLowerCase()) >= 0) return item;
	});

	return (
		<div
			css={css`
				position: relative;
				width: 100%;
			`}
			ref={dropdownRef}
		>
			<div
				css={css`
					height: ${sizeMedium ? 36 : 44}px;

					padding: ${sizeMedium ? '7px 12px' : '12px'};

					border: 1px solid #d4d5de;
					border-radius: 8px;

					font-size: 14px;
					line-height: 20px;
					position: relative;
					background: #fff;

					user-select: none;

					${isCompositePrefix &&
					css`
						border: 0;
						height: 100%;
						border-right: inset 1px solid #d4d5de;
						border-radius: 8px 0 0 8px;
						margin-right: 2px;
					`}

					&:hover {
						background: ${theme.color.primary['50']};
						cursor: pointer;
					}

					${error &&
					css`
						border-color: #ff6767;
					`}

					${!value &&
					css`
						color: #8c8fa6;
					`}

					${isOpen &&
					css`
						box-shadow: 0 0 0 2px ${theme.color.primary['400']};
						border-color: transparent;
					`}
				`}
				onClick={toggle}
			>
				{!value && placeholder}

				{!!currentOption?.icon && value ? (
					<div
						css={css`
							display: flex;
							align-items: center;
						`}
					>
						{currentOption.icon}

						<span
							css={css`
								padding-left: 8px;
							`}
						>
							{currentOption.label}
						</span>
					</div>
				) : (
					!!value && currentOption.label
				)}

				<div
					css={css`
						position: absolute;

						top: ${sizeMedium ? 6 : 10}px;

						right: 16px;
						transition: all 0.2s ease-in-out;

						${isOpen &&
						css`
							top: ${sizeMedium ? 9 : 13}px;
							transform: rotateZ(180deg);
							transition: all 0.2s ease-in-out;
						`}
					`}
				>
					<svg
						width="10px"
						height="5px"
						viewBox="0 0 10 5"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
						xmlnsXlink="http://www.w3.org/1999/xlink"
					>
						<g id="Booking" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
							<polygon
								id="Triangle"
								fill="#7F829C"
								transform="translate(5.000000, 2.500000) rotate(-180.000000) translate(-5.000000, -2.500000) "
								points="5 0 10 5 0 5"
							></polygon>
						</g>
					</svg>
				</div>
			</div>

			{isOpen && (
				<div
					css={css`
						position: absolute;
						left: 0;
						top: 100%;
						background: #fff;
						box-shadow: 0 20px 32px -8px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05);
						min-width: 100%;
						border-radius: 8px;
						z-index: 1;
						margin-top: 2px;
					`}
				>
					{filterable && (
						<div>
							<Input
								name="search"
								placeholder="Hledat kalendář..."
								underline
								autofocus
								icon={<IconSearch />}
								onChange={(e) => {
									setSearchInputValue(e.target.value);
								}}
							/>
						</div>
					)}

					<div
						css={[
							css`
								padding: 6px 0;
								max-height: 320px;
								overflow: auto;
							`,
							ScrollBarStyle(),
						]}
					>
						{filteredOptions?.map(({ label, value, icon }) => {
							return (
								<div
									key={value}
									css={css`
										padding: 8px 16px 8px 12px;
										margin: 2px 8px;
										border-radius: 8px;

										&:hover {
											background: ${theme.color.primary['50']};
											cursor: pointer;
										}
									`}
									onClick={() => {
										onChange(value);
										toggle();
									}}
								>
									{!!icon ? (
										<div
											css={css`
												display: flex;
												align-items: center;
											`}
										>
											{icon}
											<span
												css={css`
													padding-left: 8px;
												`}
											>
												{label}
											</span>
										</div>
									) : (
										label
									)}
								</div>
							);
						})}

						{!filteredOptions.length && (
							<div
								css={css`
									padding: 20px;
									display: flex;
									flex-direction: column;
									align-items: center;
								`}
							>
								<div>
									<strong>Nenalezeno</strong>
								</div>
								<div
									css={css`
										font-size: 13px;
									`}
								>
									Zrušit vyhledávání
								</div>
							</div>
						)}
					</div>
				</div>
			)}
		</div>
	);
};
